import { useEffect, useState } from "react";
import { countQueued, onPendingChanged } from "../lib/offlineQueue";

// Shared hook so any component can render the global pending count.
export function usePendingCount() {
    const [count, setCount] = useState(0);
    useEffect(() => {
        let alive = true;
        countQueued().then((n) => { if (alive) setCount(n); });
        const off = onPendingChanged((n) => { if (alive) setCount(n); });
        return () => { alive = false; off(); };
    }, []);
    return count;
}
